export default "__VITE_ASSET__DalbjC$U__ 1920w";